import { useEffect, useState } from "react";

import useService from "../../../../hooks/useService";
import { normalizeChartRecord } from "../helpers/functions";

export default function useAnalyticsChartData(dataUrl, filters = null) {
  const analyticsChartRepository = useService("repositories/analytics-chart-repository");
  const filterString = filters instanceof URLSearchParams ? filters.toString() : "";

  const [state, setState] = useState({ isLoading: false, error: null, record: null });

  useEffect(() => {
    let isActive = true;

    async function load() {
      if (!dataUrl) {
        if (isActive) {
          setState({ isLoading: false, error: null, record: null });
        }
        return;
      }

      if (isActive) {
        setState({ isLoading: true, error: null, record: null });
      }

      try {
        const record = await analyticsChartRepository.fetchByUrl(
          dataUrl,
          new URLSearchParams(filterString)
        );
        if (isActive) {
          setState({ isLoading: false, error: null, record: normalizeChartRecord(record) });
        }
      } catch (error) {
        if (isActive) {
          setState({ isLoading: false, error, record: null });
        } else {
          console.error("Failed to fetch analytics chart data", error);
          return error;
        }
      }
    }

    load();

    return () => {
      isActive = false;
    };
  }, [analyticsChartRepository, dataUrl, filterString]);

  return state;
}
